import request from "@/utils/request2";
// 查询需求池列表
export function listDemand(query) {
  return request({
    url: '/system/workOrderDemand/getListByPhone',
    method: 'get',
    params: query
  })
}
// 查询需求池详细
export function getDemand(id) {
  return request({
    url: '/system/workOrderDemand/' + id,
    method: 'get'
  })
}
// 根据手机号查权限
export function getRoleByPhone(query) {
  return request({
    url: '/system/workOrderRole/getRoleByPhone',
    method: 'get',
    params: query
  })
}
// 根据用户信息
export function getInfo(query) {
  return request({
    url: 'system/personnel/getInfo',
    method: 'get',
    params: query
  })
}

// 新增需求池
export function addDemand(data) {
  return request({
    url: '/system/workOrderDemand',
    method: 'post',
    data: data
  })
}

// 修改需求池
export function updateDemand(data) {
  return request({
    url: '/system/workOrderDemand',
    method: 'put',
    data: data
  })
}
export function listOrder(query) {
  return request({
    url: '/system/workOrder/list',
    method: 'get',
    params: query
  })
}
export function listOrderByPhone(query) {
  return request({
    url: '/system/workOrder/getListByPhone',
    method: 'get',
    params: query
  })
}
// 查询工单基本信息详细
export function getOrder(id) {
  return request({
    url: '/system/workOrder/' + id,
    method: 'get'
  })
}
// 修改工单基本信息
export function updateOrder(data) {
  return request({
    url: '/system/workOrder',
    method: 'put',
    data: data
  })
}
// 查询人员列表
export function listPersonnel(query) {
  return request({
    url: '/system/personnel/list',
    method: 'get',
    params: query
  })
}
// 新增工单子任务
export function addTask(data) {
  return request({
    url: '/system/workOrderTask',
    method: 'post',
    data: data
  })
}
// 查询工单子任务列表
export function listTask(query) {
  return request({
    url: '/system/workOrderTask/list',
    method: 'get',
    params: query
  })
}

// 查询工单子任务详细
export function getTask(id) {
  return request({
    url: '/system/workOrderTask/' + id,
    method: 'get'
  })
}
// 修改工单子任务
export function updateTask(data) {
  return request({
    url: '/system/workOrderTask',
    method: 'put',
    data: data
  })
}
// 修改工单子任务状态
export function updateStatus(data) {
  return request({
    url: '/system/workOrderTask/updateStatus',
    method: 'post',
    data: data
  })
}
// 查询子任务操作记录列表
export function listOperation(query) {
  return request({
    url: '/system/operation/list',
    method: 'get',
    params: query
  })
}
// 查询项目列表
export function listProject(query) {
  return request({
    url: '/system/project/list',
    method: 'get',
    params: query
  })
}
// 新增工单基本信息
export function addOrder(data) {
  return request({
    url: '/system/workOrder',
    method: 'post',
    data: data
  })
}
// 查询需求池列表
export function listDemandNo(query) {
  return request({
    url: '/system/workOrderDemand/list',
    method: 'get',
    params: query
  })
}